module.exports = __webpack_public_path__ + "img/gold.9eb85a4d.png";